import React from "react";

interface HalfFilledTriangleIconProps {
  className?: string;
}

export const HalfFilledTriangleIcon: React.FC<HalfFilledTriangleIconProps> = ({
  className = "",
}) => (
  <svg
    className={className}
    viewBox="0 0 12 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.73367 3.12567C6.65912 2.99715 6.55211 2.89047 6.42337 2.81631C6.29462 2.74216 6.14865 2.70312 6.00007 2.70312C6.00007 2.70312 6.00007 3.05642 6.00007 3.12567C6.00007 3.40972 6.00007 3.76302 6.00007 3.76302L6.00003 7.64931C6.00003 7.64931 6.00011 7.85381 6.00007 8.00261C6.00003 8.15141 6.00007 8.70921 6.00007 8.70921C6.00007 8.70921 5.99995 9.54993 6.00003 9.76911C6.00007 9.91002 6.00005 10.1224 6.00004 10.3344H9.39244C9.54123 10.3343 9.68737 10.295 9.81618 10.2205C9.94498 10.146 10.0519 10.0389 10.1263 9.91002C10.2006 9.78112 10.2397 9.63493 10.2397 9.48614C10.2396 9.33734 10.2004 9.19117 10.126 9.06231L6.73367 3.12567Z"
      fill="#F5F5F6"
    />
    <path
      d="M6.77866 2.82423C6.69953 2.68782 6.58595 2.57459 6.44929 2.49587C6.31264 2.41716 6.1577 2.37573 6 2.37573C5.8423 2.37573 5.68736 2.41716 5.55071 2.49587C5.41405 2.57459 5.30047 2.68782 5.22134 2.82423L1.6206 9.12552C1.54163 9.2623 1.50004 9.41745 1.5 9.57538C1.49996 9.73332 1.54147 9.88849 1.62037 10.0253C1.69927 10.1621 1.81278 10.2758 1.94949 10.3549C2.08621 10.4339 2.24132 10.4756 2.39926 10.4758H9.60074C9.75868 10.4756 9.91379 10.4339 10.0505 10.3549C10.1872 10.2758 10.3007 10.1621 10.3796 10.0253C10.4585 9.88849 10.5 9.73332 10.5 9.57538C10.5 9.41745 10.4584 9.2623 10.3794 9.12552L6.77866 2.82423Z"
      stroke="#F5F5F6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default HalfFilledTriangleIcon;
